import { render, staticRenderFns } from "./ylzl.vue?vue&type=template&id=0aa3102c&scoped=true&"
import script from "./ylzl.vue?vue&type=script&lang=js&"
export * from "./ylzl.vue?vue&type=script&lang=js&"
import style0 from "./ylzl.vue?vue&type=style&index=0&id=0aa3102c&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0aa3102c",
  null
  
)

export default component.exports